import {
  ManageTaskTemplates,
  AddTaskTemplate,
} from '../../../assets/img/guide';

const addingTaskTemplateCopy = {
  pageTitle: 'Manage Task Templates',
  pageSubtitle: `
    Medsender allows you to create custom Task Templates. Add a document category trigger to create the task
    automatically when a matching fax is auto-uploaded, or pick a template manually to auto-fill fields on the
    Send to Chart and Create Task modals.`,
  sections: [
    {
      title: 'Managing your Task Templates',
      id: 'manageTaskTemplates',
      subtitle: `Navigate to settings and find the "Manage Task Templates" tab.
      From here, you can edit, add, or delete templates. Only an admin can create a template whose audience
      is a Department or the whole Organization — and only those templates can have a trigger.`,
      img: ManageTaskTemplates,
    },
    {
      title: 'Adding a Task Template',
      id: 'addingTaskTemplate',
      subtitle: `Pick who can use the template, optionally choose the document category that triggers it
      automatically, then fill in the task EMA should create. The template name is what users see in the
      Send to Chart and Create Task modals.`,
      img: AddTaskTemplate,
    },
  ],
};

export default addingTaskTemplateCopy;
